import './style.scss'

type Props = {
	label?: string
}

const Badge = ({ label = 'Pro' }: Props) => {
	return <span className='hint'>{label}</span>
}

export default Badge
